import BaseUseCase from "../../base_use_case.js";

class ConfirmInvestmentUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: 'post',
      url: '/api/v1/projects/investment_steps/confirm_investment_email',
      data: {
        token: identifier
      }
    });
  }
}

const instance = new ConfirmInvestmentUseCase();
export default instance;